import { render, staticRenderFns } from "./IntegratorSensediaConfigTab.vue?vue&type=template&id=f5e7c908"
import script from "./IntegratorSensediaConfigTab.vue?vue&type=script&lang=ts"
export * from "./IntegratorSensediaConfigTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports